import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { FiCamera, FiCheck, FiMoreVertical } from 'react-icons/fi';
import { HOME_EASE, HomeFloat } from './HomeMotion';
import snapBillPhoto from '../../../images/home/snapbill-photo.png';

const FIELDS = [
  { label: 'Vendor', value: 'Acme Supplies Co.' },
  { label: 'Invoice #', value: 'INV-2024-0987' },
  { label: 'Invoice Date', value: 'Oct 15, 2024' },
  { label: 'Due Date', value: 'Nov 14, 2024' },
  { label: 'Total Amount', value: '$2,450.00', strong: true },
];

const HomeSnapBillVisual = () => {
  const reduce = useReducedMotion();

  return (
    <div className="home-snap-stage">
      <div className="home-snap-photo-wrap">
        <motion.img
          src={snapBillPhoto}
          alt="Professional capturing an invoice with Snap Bill"
          className="home-snap-photo"
          draggable="false"
          initial={reduce ? false : { opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.28 }}
          transition={{ duration: 0.7, ease: HOME_EASE }}
        />
      </div>

      <HomeFloat
        className="home-float--snap-scan"
        cardClassName="home-float-card--pill home-float-card--pill-done"
        enterDelay={0.18}
        inView
        drift={{ x: -5, y: -9, duration: 6.1, durationX: 7.3 }}
      >
        <span className="home-task-pill-check">
          <FiCheck />
        </span>
        Scanned
      </HomeFloat>

      <HomeFloat
        className="home-float--snap-panel"
        cardClassName="home-float-card--snap-panel"
        enterDelay={0.22}
        inView
        drift={{ x: 4, y: -10, duration: 5.4, durationX: 6.8 }}
      >
        <header className="home-snap-panel-head">
          <span className="home-snap-panel-icon">
            <FiCamera />
          </span>
          <div>
            <strong>Snap Bill</strong>
            <p>Extracted Data</p>
          </div>
          <FiMoreVertical />
        </header>

        <ul className="home-snap-fields">
          {FIELDS.map((field, index) => (
            <motion.li
              key={field.label}
              initial={reduce ? false : { opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.35 + index * 0.1, ease: HOME_EASE }}
            >
              <div>
                <span>{field.label}</span>
                <strong className={field.strong ? 'is-amount' : undefined}>{field.value}</strong>
              </div>
              <motion.em
                className="home-snap-check"
                initial={reduce ? false : { scale: 0, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: 0.5 + index * 0.1, ease: HOME_EASE }}
              >
                <FiCheck />
              </motion.em>
            </motion.li>
          ))}
        </ul>

        <div className="home-snap-foot">
          <span className="home-snap-foot-icon">
            <FiCheck />
          </span>
          Data extracted and ready to sync to your workflow.
        </div>
      </HomeFloat>
    </div>
  );
};

export default HomeSnapBillVisual;
